// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19KCM","type":"styles_type__2OHZ4","choices":"styles_choices__1JYHy"};